import { HistoryIcon, PlayIcon, RotateCcwIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Button } from '@/components/ui/button';

interface ReplayButtonProps {
  sessionId?: string;
  lastSeen?: string[];
  onClick?: () => void;
  onPrefetch?: () => void;
  disabled?: boolean;
}

export const ReplayButton = ({
  sessionId,
  lastSeen,
  onClick,
  onPrefetch,
  disabled,
}: ReplayButtonProps) => {
  const { t } = useTranslation();

  const isLastSeen = sessionId && lastSeen?.[lastSeen.length - 1] === sessionId;
  const isRecentlySeen = sessionId && !isLastSeen && lastSeen?.includes(sessionId);
  const tooltipContent = isLastSeen ? t('common.last_seen') : t('common.replay');
  const variant = isLastSeen || isRecentlySeen ? 'outline-neutral' : 'secondary-neutral';
  const Icon = isLastSeen ? HistoryIcon : isRecentlySeen ? RotateCcwIcon : PlayIcon;

  const handleClick = (e: React.MouseEvent) => {
    // preventDefault so the click doesn't trigger the row's wrapping <Link> navigation
    e.preventDefault();
    e.stopPropagation();
    onClick?.();
  };

  return (
    <InfoTooltip content={tooltipContent} side="left">
      <Button
        disabled={disabled}
        variant={variant}
        size="icon-lg"
        onClick={handleClick}
        onMouseEnter={onPrefetch}
        aria-label={t('common.replay')}
      >
        <Icon size={16} />
      </Button>
    </InfoTooltip>
  );
};
